import React from "react";
import { useApp } from "@/context/AppContext";

export default function ProtectedRoute({ children }) {
  const { authReady, user } = useApp();
  if (!authReady) return <div className="rbl-auth-wrap"><div className="rbl-spinner" /></div>;
  if (!user) {
    window.location.replace("/login");
    return null;
  }
  return children;
}
